import { enableAllPlugins, produce } from 'immer';

enableAllPlugins();

export const emailProjectPageReducer = (state, action) =>
  produce(state, (draftState) => {
    switch (action.type) {
      case 'UPDATE_FORM_FIELD':
        draftState.application.form[action.payload.name] = action.payload.value;
        break;
    }
  });

export const emailProjectPageInitialStore = {
  domain: {
    message: { data: {} },
    userCollection: { data: {}, allDataIds: [] },
    versionCollection: { data: {}, allDataIds: [] },
  },
  application: {
    pending: { message: true },
    form: {
      evidenceIncluded: false,
      message: '',
      password: '',
      passwordRequired: false,
      previouslyUsed: [],
      previouslyUsedEmailAddresses: [],
      ramsIncluded: false,
      sendToSelf: false,
      subject: '',
      to: [],
      trainingReportIncluded: false,
    },
  },
};
